import { FC } from 'react';
import { Dropdown, Label, RadioGroup } from '@silverfort/sf-components';
import { Controller, useFormContext } from 'react-hook-form';
import { SILVERFORT_TOKEN_LIST, THIRD_PARTY_TOKEN_LIST } from '../../../../consts';
import { EnrollmentEmailFormValues } from '../../../../types/forms';
import { RadioGroupOptionValue } from '@silverfort/sf-components/dist/RadioGroup/RadioGroup';

const TOKEN_RADIO_GROUP_OPTIONS = [
    { title: 'Silverfort tokens', value: 'silverfort' },
    { title: '3rd party tokens', value: 'thirdParty' }
];

interface Props {
    onTokenTypeChange: (selectedType: RadioGroupOptionValue) => void;
    onTokenTypeIdChange: (selectedTokenTypeId: number | number[] | undefined) => void;
}

export const TokenSection: FC<Props> = ({ onTokenTypeChange, onTokenTypeIdChange }) => {
    const { control, watch } = useFormContext<EnrollmentEmailFormValues>();
    const selectTokenType = watch('tokenType');

    return (
        <div className="h-20 flex flex-row gap-[85px] px-4 items-center">
            <Label text="Token" className="self-start pt-[15px]" />
            <div className="flex flex-row gap-12">
                <Controller
                    name="tokenType"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <RadioGroup
                            containerClassName="gap-4"
                            orientation="vertical"
                            selectedOption={value}
                            options={TOKEN_RADIO_GROUP_OPTIONS}
                            onChange={(value) => {
                                onTokenTypeChange(value);
                                onChange(value);
                            }}
                            itemContainerClassName="h-8"
                        />
                    )}
                />

                <div className="flex flex-col gap-4">
                    <Controller
                        name="tokenTypeId"
                        control={control}
                        render={({ field: { value } }) => (
                            <>
                                <Dropdown
                                    disabled={selectTokenType !== 'silverfort'}
                                    size="small"
                                    variant="trigger"
                                    items={Object.values(SILVERFORT_TOKEN_LIST)}
                                    onChange={(value) => {
                                        onTokenTypeIdChange(value);
                                    }}
                                    selectedItems={selectTokenType !== 'silverfort' ? undefined : value}
                                    text='Select platform'
                                />
                                <Dropdown
                                    disabled={selectTokenType !== 'thirdParty'}
                                    size="small"
                                    variant="trigger"
                                    items={Object.values(THIRD_PARTY_TOKEN_LIST)}
                                    onChange={(value) => {
                                        onTokenTypeIdChange(value);
                                    }}
                                    selectedItems={selectTokenType !== 'thirdParty' ? undefined : value}
                                    text='Select provider'
                                />
                            </>
                        )}
                    />
                </div>
            </div>
        </div>
    );
};
